<template>
  <div class="header-controls" id="header__controls__osmp">
    <b-modal centered hide-footer id="feedbackModal" title="Send Feedback">
      <FeedbackModal ref="refFeedbackModal" />
    </b-modal>
    <div class="container-fluid">
      <div class="row">
        <div :class="getHeaderClasses">
          <div
            :class="`form-inline ${$router.currentRoute.name == 'dashboard' || $router.currentRoute.name == 'myWeek' ? 'deliverable-filter-form' : ''}`"
            v-if="$router.currentRoute.name != 'permissionManager' && $router.currentRoute.name != 'globalAlert' && $router.currentRoute.name != 'userGlobalAlert'">
            <div class="input-group top-search">
              <input type="text" class="form-control"
                :class="$router.currentRoute.name == 'globalSearch' ? '' : 'media-calls-search'" v-model="searchQuery"
                v-debounce:500ms="setQuery" :debounce-events="['keyup']" :placeholder="querySearchPlaceHolder"
                @click="$refs.searchQuery.select()" @keypress.enter="triggerSearch" ref="searchQuery" id="search-query" />
              <div class="input-group-append cursor-pointer" @click="triggerSearch">
                <span class="input-group-text">
                  <i class="fas fa-search"></i>
                </span>
              </div>
            </div>
            <b-button ref="filterBoxBtn" :id="`sm-plan-popover-button-event-${tabTitle}`"
              class="ml-2 mr-2 header-filter-btns" variant="theme" tabindex="0" href="#"
              v-if="$router.currentRoute.name != 'globalSearch'" @keydown.esc="$refs.popover.$emit('close')">
              <span
                :class="{ 'wider-filter-only': $router.currentRoute.name == 'dashboard' || $router.currentRoute.name == 'myWeek' }">Filter</span>
              <img src="@/csmworkflow/img/filter.svg" />
            </b-button>
            <b-popover triggers="click blur" boundary="window" placement="bottom" ref="popover"
              :target="`sm-plan-popover-button-event-${tabTitle}`" custom-class="deliverable-filter">
              <div class="d-flex flex-row">
                <div class="filter-item item__status">
                  <label>Post Status</label>
                  <div v-if="!isMobile()" class="status-wrap">
                    <a href="#" @click.prevent="setPublishStatusFilter(s)" class="badge mr-2"
                      :style="{ color: '#fff', backgroundColor: s.color }" v-for="(s, index) in publishStatuses"
                      :key="index">{{ s.name }}</a>
                  </div>
                  <div class="custom-field status-field">
                    <multiselect v-if="isMobile()" :searchable="true" v-model="planFilterQuery.publishStatus" label="name"
                      :options="publishStatuses" placeholder="Select post status" :show-labels="false" :multiple="true"
                      :hide-selected="true">
                      <template slot="option" slot-scope="props">
                        <div
                          :style="{ color: '#fff', borderRadius: '10px', backgroundColor: props.option.color, height: '40px', lineHeight: '40px', textAlign: 'center' }">
                          {{ props.option.name }}</div>
                      </template>
                      <template slot="tag" slot-scope="props">
                        <div
                          :style="{ color: '#fff', borderRadius: '10px', backgroundColor: props.option.color, textAlign: 'center', display: 'inline-block', padding: '5px 10px', marginRight: '5px' }">
                          {{ props.option.name }}</div>
                      </template>
                    </multiselect>
                  </div>
                </div>
                <div class="grouped-filter-item">

                  <div class="filter-item item__coordinator">
                    <label>Assigned To</label>
                    <div class="coordinator-wrap">
                      <multiselect ref="coordinatorFilter" id="coordinator" v-model="selectedCoordinators"
                        :options="allActiveUsers" :show-labels="false" :multiple="true" open-direction="bottom"
                        label="name" track-by="id" :hide-selected="true" :close-on-select="false"
                        :clear-on-select="false" 
                        @select="onUpdateMultiselect" @remove="onRemoveMultiselect" >
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} options
                            selected</span>
                        </template>
                      </multiselect>
                    </div>
                  </div>

                  <div class="filter-item item__social_network">
                    <label>Social Network</label>
                    <div class="social-network-wrap">
                      <multiselect ref="socialNetworkFilter" id="socialNetwork" v-model="selectedSocialNetworks"
                        :options="systemSettings.social_networks || []" :show-labels="false" :multiple="true"
                        open-direction="bottom" label="network_name" track-by="id" 
                        :hide-selected="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                        :loading="!systemSettings.social_networks" 
                        @select="onUpdateMultiselect"  @remove="onRemoveMultiselect" >
                        <template slot="option" slot-scope="props">
                          <div>
                            <i :class="`fab fa-${getSocialNetworkClass(props.option.api_type)}`"></i> {{ props.option.network_name }}
                          </div>
                        </template>
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} options
                            selected</span>
                        </template>
                      </multiselect>
                    </div>
                  </div>



                  <div class="filter-item item__projectPlan" v-if="namespace == ''">
                    <label>Project/Social Media Plan</label>
                    <div class="projectPlan-wrap">
                      <multiselect ref="parentDeliverablesFilter" id="projectPlan" v-model="selectedParentDeliverables" :options="parentDeliverables" :show-labels="false"
                        :multiple="true" open-direction="bottom" label="name" track-by="id" 
                        :hide-selected="true" :close-on-select="false" :clear-on-select="false" :loading="isProjectPlansLoading"
                        :preserve-search="true" 
                        @search-change="onProjectPlanSearch" @select="onUpdateMultiselect"  @remove="onRemoveMultiselect" >
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} options
                            selected</span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <span class="option__desc">
                            <span v-if="props.option.project_title" 
                            class="option__small text-muted">{{ props.option.project_title }}</span>
                            <br v-if="props.option.project_title" />
                            <span class="option__title">{{ props.option.deliverable_title }}</span>
                          </span>
                        </template>
                        <template slot="noOptions">Start typing to find projects / plans.</template>
                        <template slot="noResult">No results. Please try changing the search query.</template>
                      </multiselect>
                    </div>
                  </div>


                </div>

                <div class="grouped-filter-item">

                  <div class="filter-item item__tag">
                    <label>Tag</label>
                    <div class="tag-wrap">
                      <multiselect ref="tagFilter" id="tag" v-model="selectedTags" :options="tags" :show-labels="false"
                        :multiple="true" open-direction="bottom" label="name" track-by="id" 
                        :hide-selected="true" :close-on-select="false" :clear-on-select="false" :loading="isTagsLoading"
                        :preserve-search="true" 
                        @search-change="onTagSearch" @select="onUpdateMultiselect"  @remove="onRemoveMultiselect" >
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} options
                            selected</span>
                        </template>
                        <template slot="noOptions">Start typing to find tags.</template>

                        <template slot="noResult">No results. Please try changing the search query.</template>
                      </multiselect>
                    </div>
                  </div>

                  <div class="filter-item item__department">
                    <div>
                      <label>Department</label>
                      <b-form-checkbox v-if="isMobile()" class="float-right csm-checkbox"
                        v-model="planFilterQuery.noDepartment" id="no-department" name="no-department" value="accepted"
                        unchecked-value="not_accepted"
                        @input="planFilterQuery.noDepartment == 'accepted' ? planFilterQuery.department = [] : ''">No
                        Department</b-form-checkbox>
                    </div>
                    <div class="tag-wrap">
                      <multiselect ref="departmentFilter" id="department" v-model="selectedDepartments"
                        open-direction="bottom" label="name" track-by="id" :options="allActiveDepartments"
                         :hide-selected="true" :show-labels="false" :multiple="true"
                        :close-on-select="false" :clear-on-select="false" 
                        @select="onUpdateMultiselect"  @remove="onRemoveMultiselect" >
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} options
                            selected</span>
                        </template>
                        <template slot="noOptions">Start typing to find departments.</template>

                        <template slot="noResult">No results. Please try changing the search query.</template>
                      </multiselect>
                    </div>
                    <b-form-checkbox v-if="!isMobile()" class="mt-2 csm-checkbox" v-model="planFilterQuery.noDepartment"
                      id="no-department" name="no-department" value="accepted" unchecked-value="not_accepted"
                      @input="planFilterQuery.noDepartment == 'accepted' ? planFilterQuery.department = [] : ''">No
                      Department</b-form-checkbox>
                  </div>

                </div>

                <div class="filter-item item__date"
                  :class="{ 'filter-item-no-border': $router.currentRoute.name == 'calendar' }">
                  <div class="due__created__dates">

                    <div>
                      <label class="mt-2">Created</label>
                      <br />
                      <date-range-picker ref="pickerDateCreated" @update="onUpdateDateCreated" :autoApply="true"
                        :ranges="customCreatedDateRanges" v-model="planFilterQuery.dateCreatedRange"></date-range-picker>
                    </div>

                    <div>
                      <label class="mt-lg-2">Post Date</label>
                      <br />
                      <date-range-picker ref="pickerPublishDate" @update="onUpdatePublishDate" :autoApply="true"
                        :ranges="customPublishDateRanges" v-model="planFilterQuery.datePublishRange"></date-range-picker>
                    </div>

                    <div>
                      <label class="mt-lg-2">Has Post Date</label>
                      <multiselect :class="'single-select'" id="hasPostDate" v-model="selectedHasPostDate"
                        :options="hasPostDateFilterOptions" :searchable="false"
                        :close-on-select="true" :show-labels="false" label="name" track-by="id" :multiple="false" 
                        @select="onUpdateMultiselect"  @remove="onRemoveMultiselect" >
                      </multiselect>
                    </div>

                  </div>
                </div>

                <div>
                  <div class="item__reset">
                    <b-button variant="theme" title="Reset All Filter" size="sm" @click="resetFilter"><i
                        class="fas fa-undo"></i></b-button>
                    <b-button class="d-block d-lg-none" variant="theme" title="Close Filter Popup" size="sm"
                      @click="$refs.popover.$emit('close')"><i class="fas fa-times"></i></b-button>
                  </div>
                </div>
              </div>
              <div class="d-none d-md-block mt-3" v-if="isFilterActive()">
                <label>Click to remove filters :</label>
                <br />
                <span class="badge badge-primary mr-2 mb-2" @click="clearSearchFilter"
                  :style="{ cursor: 'pointer' }">{{ planFilterQuery.query }}</span>
                <span class="badge mr-2 mb-2" @click="removeFilter(publishStatus)"
                  :style="{ cursor: 'pointer', color: '#fff', backgroundColor: publishStatus.color }"
                  v-for="publishStatus in planFilterQuery.publishStatus">{{ publishStatus.name }}</span>
                <span class="badge mr-2 mb-2 bg-primary cursor-pointer" @click="removeFilter(socialNetwork)"
                  style="color: #fff;" v-for="socialNetwork in planFilterQuery.socialNetwork"><i
                    :class="`fab fa-${getSocialNetworkClass(socialNetwork.api_type)}`"></i> {{ socialNetwork.network_name }}</span>

                <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(coordinator)"
                  :style="{ cursor: 'pointer' }" v-for="coordinator in planFilterQuery.coordinator">{{ coordinator.name
                  }}</span>

                  <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(filterParentDeliverable)"
                    :style="{ cursor: 'pointer' }" v-for="filterParentDeliverable in planFilterQuery.filterParentDeliverable">{{ filterParentDeliverable.name
                    }}</span>


                <span class="badge badge-primary mr-2 mb-2" @click="removeFilter('filterByDateCreated')"
                  :style="{ cursor: 'pointer' }" v-if="planFilterQuery.filterByDateCreated">Created: {{
                    planFilterQuery.dateCreatedRange.startDate | moment('MMM DD') }} - {{
    planFilterQuery.dateCreatedRange.endDate |
    moment('MMM DD') }}</span>
                <span class="badge badge-primary mr-2 mb-2" @click="removeFilter('filterByPublishDate')"
                  :style="{ cursor: 'pointer' }" v-if="planFilterQuery.filterByPublishDate">Date to Post: {{
                    planFilterQuery.datePublishRange.startDate | moment('MMM DD') }} - {{
    planFilterQuery.datePublishRange.endDate |
    moment('MMM DD') }}</span>
                <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(tag)" :style="{ cursor: 'pointer' }"
                  v-for="tag in planFilterQuery.tag">{{ tag.name }}</span>
                <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(socialSeries)"
                  :style="{ cursor: 'pointer' }" v-for="socialSeries in planFilterQuery.socialSeries">{{ socialSeries.name
                  }}</span>
                <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(socialCampaign)"
                  :style="{ cursor: 'pointer' }" v-for="socialCampaign in planFilterQuery.socialCampaign">{{
                    socialCampaign.name
                  }}</span>
                <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(department)"
                  :style="{ cursor: 'pointer' }" v-for="department in planFilterQuery.department">{{ department.name
                  }}</span>
                <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(project)" :style="{ cursor: 'pointer' }"
                  v-for="project in planFilterQuery.project">{{ project.title }}</span>
                <span class="badge badge-primary mr-2 mb-2" @click="planFilterQuery.noDepartment = 'not_accepted'"
                  :style="{ cursor: 'pointer' }" v-if="planFilterQuery.noDepartment == 'accepted'">No Department</span>

                <span class="badge badge-primary mr-2 mb-2" @click="removeFilter('hasPostDate')"
                  :style="{ cursor: 'pointer' }" v-if="planFilterQuery.hasPostDate == '1'">Has Post Date</span>
                <span class="badge badge-primary mr-2 mb-2" @click="removeFilter('hasPostDate')"
                  :style="{ cursor: 'pointer' }" v-if="planFilterQuery.hasPostDate == '0'">No Post Date</span>
              </div>
            </b-popover>

            <!-- Hardcoded -->
            <div class="new-deliverables mr-2" v-if="$router.currentRoute.name == 'mediaCallPage'">
              <button type="button" class="btn btn-theme header-filter-btns"
                @click="createDeliverableDropdownClick({ id: 'media_call', name: 'Media Call' })">
                New Media Call <i class="fas text-primary float-right fa-plus fa-fw"></i>
              </button>
            </div>

            <!-- Hardcoded -->
            <div class="new-deliverables mr-2" v-if="!getSystemSetting('social_media___post_requires_plan') || parentDeliverableId != null">
              <button type="button" class="btn btn-theme header-filter-btns"
                @click="createDeliverableDropdownClick({ id: 'social_media', name: 'Social Media' })">
                New Social Media Post <i class="fas text-primary float-right fa-plus fa-fw"></i>
              </button>
            </div>

            <div class="filter-item item__socialCampaigns mr-2"
              v-if="getSystemSetting('social_media___enable_social_campaign')"
              style="max-width: 200px">
              <div class="socialCampaigns-wrap">
                <multiselect ref="socialCampaignsFilter" id="socialCampaign" v-model="planFilterQuery.socialCampaign"
                  :options="socialCampaigns" :show-labels="false" :multiple="true" open-direction="bottom" label="name"
                  track-by="id" :hide-selected="true" :close-on-select="false"
                  :clear-on-select="false" :loading="isSocialCampaignsLoading" :preserve-search="true"
                  placeholder="Social Campaign" 
                  @search-change="onSocialCampaignSearch" @select="onUpdateMultiselect"  @remove="onRemoveMultiselect" >
                  <template slot="selection" slot-scope="{ values, search, isOpen }">
                    <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} options
                      selected</span>
                  </template>
                  <template slot="noOptions">Start typing to find social campaign.</template>

                  <template slot="noResult">No results. Please try changing the search query.</template>
                </multiselect>
              </div>
            </div>

            <div class="filter-item item__socialSeries"
              v-if="getSystemSetting('social_media___enable_social_series')">
              <div class="socialSeries-wrap">
                <multiselect ref="socialSeriesFilter" id="socialSeries" v-model="planFilterQuery.socialSeries"
                  :options="socialSeriesPlural" :show-labels="false" :multiple="true" open-direction="bottom" label="name"
                  track-by="id" :hide-selected="true" :close-on-select="false"
                  :clear-on-select="false" :loading="isSocialSeriesLoading" :preserve-search="true"
                  placeholder="Multiple Date Posts" 
                  @search-change="onSocialSeriesSearch" @select="onUpdateMultiselect"  @remove="onRemoveMultiselect" >
                  <template slot="selection" slot-scope="{ values, search, isOpen }">
                    <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} options
                      selected</span>
                  </template>
                  <template slot="noOptions">Start typing to find posts with multiple dates.</template>

                  <template slot="noResult">No results. Please try changing the search query.</template>
                </multiselect>
              </div>
            </div>

            <span
              class="filter-item item__sortdates  d-inline-block float-right expand-all-area list-by-created-published mr-2"
              v-if="showCreatedPostedDateSort">
              <div class="ml-2 expand-grp cursor-pointer">
              	<b-button class="header-filter-btns expand-ctrls" :class="{ 'none-active-btn': sortBy != 'title' }"
              	  variant="theme" v-b-tooltip.hover title="List By Post Name" @click="setSortBy('title')">
              	  <span class="text">Post Name</span>
              	</b-button>
                <b-button class="header-filter-btns expand-ctrls" :class="{ 'none-active-btn': sortBy != 'publish_date' }" @click="setSortBy('publish_date')"
                  variant="theme" v-b-tooltip.hover title="List By Posting Date">
                  <span class="text">Posting Date</span>
                </b-button>
                <b-button class="header-filter-btns expand-ctrls" :class="{ 'none-active-btn': sortBy != 'created_at' }"
                  variant="theme" v-b-tooltip.hover title="List By Created Date" @click="setSortBy('created_at')">
                  <span class="text">Created Date</span>
                </b-button>

              </div>
            </span>


            <div class="post-content-switcher-wrapper mr-2">
              <div class="switch-toggle">
              	<template v-for="(lang, idx) in systemSettings.languages">
                <input class="no-focus-visible-outline" v-model="showPostContentLang" :id="'post_content_lang_'+idx" name="post_content_lang" type="radio" :value="lang.id" >
                <label class="no-focus-visible-outline" :for="'post_content_lang_'+idx" @click="showContentByLang(lang.id)" v-b-tooltip.hover :title="lang.lang_name">{{lang.lang_code}}</label>
              	</template>
                <a class="btn no-focus-visible-outline"></a>
              </div>
              <div class="switch-toggle">
              		<template v-for="(network, idx2) in getAvailableSocialNetworks">
              	  <input class="no-focus-visible-outline" v-model="showPostContentNetwork" :id="'post_content_network_'+idx2" name="post_content_network" type="radio" :value="network.id" >
              	  <label class="no-focus-visible-outline" :for="'post_content_network_'+idx2" @click="showContentByNetwork(network.id)" v-b-tooltip.hover :title="network.network_name">
                	<i :class="`fab fa-${getSocialNetworkClass(network.api_type)} platform-indicator`" ></i>
              	  </label>
              		</template>
                <a class="btn no-focus-visible-outline"></a>
              </div>
            </div>

            <span
              class="filter-item item__sortdates  d-inline-block float-right expand-all-area list-by-created-published mr-2"
              v-if="showPlanProjectAll">
              <div class="ml-2 expand-grp cursor-pointer">
              	<b-button class="header-filter-btns expand-ctrls" :class="{ 'none-active-btn': showLimitedTo != 'plan' }"
              	  variant="theme" v-b-tooltip.hover title="Display posts from this plan" @click="setLimit('parentDeliverable')">
              	  <span class="text">Plan</span>
              	</b-button>
                <b-button class="header-filter-btns expand-ctrls" :class="{ 'none-active-btn': showLimitedTo != 'project' }" @click="setLimit('project')"
                  variant="theme" v-b-tooltip.hover title="Display posts from this project.">
                  <span class="text">Project</span>
                </b-button>
                <b-button class="header-filter-btns expand-ctrls" :class="{ 'none-active-btn': showLimitedTo != 'all' }"
                  variant="theme" v-b-tooltip.hover title="Display all Social Media Posts" @click="setLimit('all')">
                  <span class="text">All</span>
                </b-button>

              </div>
            </span>

        <div class="d-inline-block float-right saved-views-area pt-15 mr-2" v-if="getSystemSetting('social_media___enable_post_import')">
					<div class="text-right">
					<div class="group-by-wrap dropdown">
						<button type="button" class="btn btn-theme header-filter-btns" data-toggle="dropdown">Export/Import<i class="fas text-primary float-right fa-chevron-down fa-fw"></i></button>
						<div class="dropdown-menu">
							<button type="button" class="dropdown-item" href="#" @click="exportSocialMediaExcel">Download Posts</button>
							<button type="button" class="dropdown-item" href="#" @click="importSocialMediaExcel" v-if="getSystemSetting('social_media___enable_post_import')">Import Posts</button>
						</div>
					</div>
					</div>
				</div>



            <div v-if="$router.currentRoute.name != 'globalSearch' && $router.currentRoute.name != 'calendar'"
              class="ml-2 mobile-expand-ctrls cursor-pointer mobile-filter-only">
              <b-button class="header-filter-btns expand-ctrls" variant="theme"
                @click="expandAll = !expandAll; toggleStatusView();">
                <span class="icon" v-show="!expandAll"><i class="fas text-primary fa-expand fa-fw"></i></span>
                <span class="icon" v-show="expandAll"><i class="fas text-primary fa-compress fa-fw"></i></span>
              </b-button>
            </div>

            <div v-if="$router.currentRoute.name == 'myWeek' || $router.currentRoute.name == 'dashboard'"
              class="ml-2 mobile-views-section cursor-pointer mobile-filter-only">
              <b-button class="header-view-btns" variant="theme" ref="MobileViewButton" id="MobileViewButton"
                v-b-modal.headerViewSelectModal>
                <span class="icon"><i class="fas fa-fw fa-eye text-primary"></i></span>
              </b-button>

            </div>

            <div v-if="$router.currentRoute.name == 'globalSearch'" class="btn-group add-new__global_search">
              <b-button @keydown.esc="$refs.GSCreatedDatePopover.$emit('close')" class="ml-md-2 header-filter-btns"
                variant="theme" @click="GSCreatedDatePopover = !GSCreatedDatePopover" ref="GSCreatedDate"
                id="GSCreatedDate">
                Created Date
                <i class="far fa-calendar-check text-primary"></i>
              </b-button>
              <b-popover ref="GSCreatedDatePopover" :show.sync="GSCreatedDatePopover" target="GSCreatedDate"
                triggers="click blur" placement="bottom" custom-class="filter_popover__gs created-date-popover">
                <date-range-picker ref="pickerDateCreated" opens="inline" @update="onUpdateDateCreated" :autoApply="true"
                  :ranges="customCreatedDateRanges" v-model="planFilterQuery.dateCreatedRange"></date-range-picker>
              </b-popover>
            </div>
            <div
              v-if="$router.currentRoute.name == 'globalSearch' && (GSDataType == 'departments' || GSDataType == 'tags' || GSDataType == 'contacts' || GSDataType == 'coordinators')"
              class="btn-group add-new__global_search">
              <div class="ml-md-2 toggle-dept-status cursor-pointer"
                @click="planFilterQuery.status[0] == 'Active' ? planFilterQuery.status = ['Archived'] : planFilterQuery.status = ['Active']">
                <b-button class="header-filter-btns" :class="{ 'none-active-btn': planFilterQuery.status[0] != 'Active' }"
                  variant="theme">
                  Active
                  <i class="fas fa-toggle-on text-primary float-right ml-2"></i>
                </b-button>
                <b-button class="header-filter-btns"
                  :class="{ 'none-active-btn': planFilterQuery.status[0] != 'Archived' }" variant="theme">
                  Archived
                  <i class="fas fa-toggle-off text-primary float-right ml-2"></i>
                </b-button>
              </div>
            </div>
            <div
              v-if="$router.currentRoute.name == 'globalSearch' && (GSDataType == 'departments' || GSDataType == 'tags')"
              class="btn-group add-new__global_search sorting">
              <button class="btn btn-theme ml-md-2 header-filter-btns dropdown-toggle" type="button"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Sort
                <i class="fas fa-sort text-primary float-right"></i>
              </button>
              <div class="dropdown-menu">
                <a class="dropdown-item" @click="setSort('usedDesc')" href="#">Frequency Descending</a>
                <a class="dropdown-item" @click="setSort('usedAsc')" href="#">Frequency Ascending</a>
              </div>
            </div>
            <div v-if="$router.currentRoute.name == 'globalSearch' && GSDataType == 'all'"
              class="btn-group add-new__global_search">
              <b-button class="ml-md-2 header-filter-btns dropdown-toggle" variant="theme" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">Add</b-button>
              <div class="dropdown-menu">
                <a v-if="userAbilities.createTag || userAbilities.editMediaCall" class="dropdown-item"
                  @click="$emit('click', 'tag')" href="#">Add Tags</a>
                <a v-if="userAbilities.createContact || userAbilities.editMediaCall" class="dropdown-item"
                  @click="$emit('click', 'contact')" href="#">Add Contacts</a>
                <a v-if="userAbilities.createUser" class="dropdown-item" @click="$emit('click', 'coordinator')"
                  href="#">Add User</a>
                <a v-if="userAbilities.createDepartment || userAbilities.editMediaCall" class="dropdown-item"
                  @click="$emit('click', 'department')" href="#">Add Departments</a>
              </div>
            </div>
            <div v-if="$router.currentRoute.name == 'globalSearch' && GSDataType != 'all'"
              :class="!checkPermissions ? 'no-permission' : ''" class="btn-group add-new__global_search specific-btn">
              <b-button v-if="checkPermissions"
                @click.prevent="$emit('click', GSDataType.substring(0, GSDataType.length - 1))" variant="theme"
                class="ml-md-2 header-filter-btns action">
                Add
                <span style="text-transform: capitalize">{{ tabType }}</span>
              </b-button>
              <div class="btn-group">
                <button type="button" v-if="checkPermissions" class="btn btn-theme dropdown-toggle options"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <b-button class="ml-md-2 header-filter-btns dropdown-toggle" v-if="!checkPermissions" variant="theme"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Add</b-button>
                <div class="dropdown-menu">
                  <a v-if="GSDataType != 'tags' && (userAbilities.createTag || userAbilities.editMediaCall)"
                    class="dropdown-item" @click="$emit('click', 'tag')" href="#">Add Tags</a>
                  <a v-if="GSDataType != 'contacts' && (userAbilities.createContact || userAbilities.editMediaCall)"
                    class="dropdown-item" @click="$emit('click', 'contact')" href="#">Add Contacts</a>
                  <a v-if="GSDataType != 'coordinators' && userAbilities.createUser" class="dropdown-item"
                    @click="$emit('click', 'coordinator')" href="#">Add User</a>
                  <a v-if="GSDataType != 'departments' && (userAbilities.createDepartment || userAbilities.editMediaCall)"
                    class="dropdown-item" @click="$emit('click', 'department')" href="#">Add Departments</a>
                </div>
              </div>
            </div>
            <div class="ml-2">
              <FeedbackBtn />
            </div>
          </div>
          <div class="mt-3 filter-badges" v-if="isFilterActive()">
            <label class="remove-filter-text">Click to remove filters:</label>
            <span class="badge badge-primary mr-2 mb-2" @click="clearSearchFilter"
              :style="{ cursor: 'pointer' }">{{ planFilterQuery.query }}</span>

            <span class="badge mr-2 mb-2" @click="removeFilter(publishStatus)"
              :style="{ cursor: 'pointer', color: '#fff', backgroundColor: publishStatus.color }"
              v-for="publishStatus in planFilterQuery.publishStatus">{{ publishStatus.name }}</span>
            <span v-if="$router.currentRoute.name == 'globalSearch' && planFilterQuery.sort"
              class="badge mr-2 mb-2 bg-primary cursor-pointer" style="color: #fff;"
              @click="removeFilter('resetDepartTagSort')">{{ planFilterQuery.sort == 'usedDesc' ? 'Frequency Descending' :
                'Frequency Ascending' }}</span>
            <span class="badge mr-2 mb-2 bg-primary cursor-pointer" @click="removeFilter(socialNetwork)"
              style="color: #fff;" v-for="socialNetwork in planFilterQuery.socialNetwork"><i
                :class="`fab fa-${getSocialNetworkClass(socialNetwork.api_type)}`"></i> {{ socialNetwork.network_name }}</span>

                    <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(filterParentDeliverable)" :style="{ cursor: 'pointer' }"
                      v-for="filterParentDeliverable in planFilterQuery.filterParentDeliverable">{{ filterParentDeliverable.name }}</span>


            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(coordinator)" :style="{ cursor: 'pointer' }"
              v-for="coordinator in planFilterQuery.coordinator">{{ coordinator.name }}</span>

            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter('filterByDateCreated')"
              :style="{ cursor: 'pointer' }" v-if="planFilterQuery.filterByDateCreated">Created: {{
                planFilterQuery.dateCreatedRange.startDate | moment('MMM DD') }} - {{
    planFilterQuery.dateCreatedRange.endDate |
    moment('MMM DD') }}</span>

            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter('filterByPublishDate')"
              :style="{ cursor: 'pointer' }" v-if="planFilterQuery.filterByPublishDate">Date to Post: {{
                planFilterQuery.datePublishRange.startDate | moment('MMM DD') }} - {{
    planFilterQuery.datePublishRange.endDate |
    moment('MMM DD') }}</span>
            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(tag)" :style="{ cursor: 'pointer' }"
              v-for="tag in planFilterQuery.tag">{{ tag.name }}</span>
            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(socialSeries)" :style="{ cursor: 'pointer' }"
              v-for="socialSeries in planFilterQuery.socialSeries">{{ socialSeries.name }}</span>
            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(socialCampaign)"
              :style="{ cursor: 'pointer' }" v-for="socialCampaign in planFilterQuery.socialCampaign">{{
                socialCampaign.name
              }}</span>
            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(department)" :style="{ cursor: 'pointer' }"
              v-for="department in planFilterQuery.department">{{ department.name }}</span>
            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(project)" :style="{ cursor: 'pointer' }"
              v-for="project in planFilterQuery.project">{{ project.title }}</span>
            <span class="badge badge-primary mr-2 mb-2" @click="planFilterQuery.noDepartment = 'not_accepted'"
              :style="{ cursor: 'pointer' }" v-if="planFilterQuery.noDepartment == 'accepted'">No Department</span>
            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter('hasPostDate')"
              :style="{ cursor: 'pointer' }" v-if="planFilterQuery.hasPostDate == '1'">Has Post Date</span>
            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter('hasPostDate')"
              :style="{ cursor: 'pointer' }" v-if="planFilterQuery.hasPostDate == '0'">No Post Date</span>

            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter('overdue')" :style="{ cursor: 'pointer' }"
              v-if="planFilterQuery.weekFilterOptions.overdue">overdue</span>
            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter('today')" :style="{ cursor: 'pointer' }"
              v-if="planFilterQuery.weekFilterOptions.today">today</span>
            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter('thisWeek')" :style="{ cursor: 'pointer' }"
              v-if="planFilterQuery.weekFilterOptions.thisWeek">this week</span>
            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter('nextWeek')" :style="{ cursor: 'pointer' }"
              v-if="planFilterQuery.weekFilterOptions.nextWeek">next week</span>
            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter('upcoming')" :style="{ cursor: 'pointer' }"
              v-if="planFilterQuery.weekFilterOptions.upcoming">upcoming</span>
            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter('noDeadline')" :style="{ cursor: 'pointer' }"
              v-if="planFilterQuery.weekFilterOptions.noDeadline">no deadline</span>


          </div>
        </div>

        <div v-if="showLogo" class="col-sm-5 col-md-4 col-4 text-right right-side">
          <div class="logo-user">
            <HeaderNotification />
            <LoggedInUser />
            <Logo />
          </div>
        </div>

      </div>
    </div>



       <b-modal centered hide-footer v-model="showSocialMediaExportModal" id="socialMediaExportModal" title="Creating Social Media Export">

      <div style="text-align:center">
      	<b-spinner v-if="isLoadingExport" label="Loading"></b-spinner>
      	<div v-if="!isLoadingExport">
      	<a class="btn btn-primary" v-if="downloadLink" :href="downloadLink" @click="showSocialMediaExportModal = false;">Download</a>
      	</div>
      </div>
    </b-modal>
    <b-modal centered hide-footer  hide-backdrop  no-close-on-backdrop  v-model="showSocialMediaImportModal" content-class="shadow" id="socialMediaImportModal" title="Import Social Media Posts">
    	<p>
    		<ul>
    			<li><a href="/assets/import-social-media.xlsx" target="_blank">Download example .xlsx file</a></li>
    			<li>We recommend importing less than 30 new social media posts at a time to reduce the file size and processing time of the excel spreadsheet.</li>
    		</ul>
    	</p>
    	<div v-show="isProcessingImport" class="status-processing-import-file">
      	<div role="status"  class="ml-2 spinner-border spinner-border-sm text-primary">
       </div>
       <span>Loading and Processing Import Entries.<br/>This may take several minutes.</span>
     </div>
    	<VueFilePond
    	    name="file"
    	    ref="importPond"
    	    label-idle="Upload .xlsx"
    	    :allow-multiple="true"
    	    :dropOnElement="true"
    	    :dropOnPage="false"
    	    :allowRevert="false"
    	    v-bind:files="filepond"
    	    v-on:init="handleFilePondInit"
    	    credits="false"
    	  />
	   	  <div class="imported-results" v-show="loadedImportResults">
	   	  	<b-button v-b-toggle.collapse-import-results variant="text">
	   	  		<i v-show="!expandImportResults" class="fas fa-chevron-down collapse-indicator"></i>
	   	  		<i v-show="expandImportResults" class="fas fa-chevron-right collapse-indicator"></i>
	   	  	  <strong style="color:var(--error--color--border)" v-if="importedResults.errors.length > 0">ERROR: {{importedResults.errors.length}} row(s) have problems.</strong>
	   	  	  <strong>{{importedResults.imported.length}} posts imported.</strong>
	   	  	  <strong>{{importedResults.total}} data rows in file.</strong>
	   	  	  <strong>Click to view details.</strong>
	   	  	  <br/>
	   	  	</b-button>
	   	  	<b-collapse id="collapse-import-results" v-model="expandImportResults">
	   	  	  <div class="collapse-inner">

	   	  	  	<ol v-if="importedResults.errors.length > 0" >
	   	  	  		<li :class="`{e.new ? 'imported-new':'imported-existing'}`" v-for="(e, indexe) in importedResults.errors" >

	   	  	  			<span class='imported-title'>{{e.title}}</span>
	   	  	  			<span class='imported-publish_date' v-if="e.publish_date != null" v-html="localMomentFull(e.publish_date)"></span>
	   	  	  			<span class='imported-publish_date' v-if="e.publish_date == null">No Date Set</span>
	   	  	  			<span class='imported-social_campaign' v-if="e.social_campaign">Campaign: {{e.social_campaign.title}}</span>
	   	  	  			<span class='imported-social_series' v-if="e.social_series">Series: {{e.social_series.title}}</span>
	   	  	  			<span :class="getImportStatusClass(e.status)">Row {{e.row}}; {{e.status.name}}</span>
	   	  	  		</li>
	   	  	  	</ol>

					<ol v-if="importedResults.imported.length > 0" >
						<li :class="`{s.new ? 'imported-new':'imported-existing'}`" v-for="(s, index) in importedResults.imported" >
							<span class='imported-title'> <a @click="showEditDeliverableModal(s)">{{s.title}}</a></span>
	   	  	  			<span class='imported-publish_date' v-if="s.publish_date != null" v-html="localMomentFull(s.publish_date)"></span>


							<span class='imported-publish_date' v-if="s.publish_date == null">No Date Set</span>

							<span class='imported-social_campaign' v-if="s.social_campaign">Campaign: {{s.social_campaign.title}}</span>
							<span class='imported-social_series' v-if="s.social_series">Series: {{s.social_series.title}}</span>

							<span :class="getImportStatusClass(s.status)">Row {{s.row}}; {{s.status.name}}</span>
						</li>
					</ol>
	   	  	  </div>
	   	  	</b-collapse>
				</div>

    </b-modal>

  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import Logo from "./Logo";
import LoggedInUser from "./LoggedInUser";
import HeaderNotification from "./HeaderNotification";
import FeedbackBtn from "./FeedbackBtn";
import FeedbackModal from "./FeedbackModal";
import ViewTitleModal from "./ViewTitleModal";
import router from "../../routes";
import vueStarRate from "vue-js-star-rating";
import vueFilePond from "vue-filepond";
const VueFilePond = vueFilePond();
import "filepond/dist/filepond.min.css";


export default {
  props: [
    "myWeek",
    "GSDataType",
    "parentDeliverableId",
    "tabTitle",
    "namespace",
    "pageCount",
    "showCreatedPostedDateSort",
    "showLogo",
    "showProjectPlanFilter",
  ],
  data() {
    return {
  		expandImportResults:false,
  		importedResults:{
  			imported:[],
  			errors:[],
  			total:0
  		},
  		loadedImportResults:false,
  	  filepond: [],
  		showSocialMediaExportModal: false,
  		showSocialMediaImportModal: false,
  		isProcessingImport:false,
  		isLoadingImport:false,
  		isLoadingExport:false,
  		downloadError:null,
  		downloadLink:null,
  		importError:null,
    	showLimitedTo:'plan',
    	sortBy:'title',
    	showPostContentLang:1,
    	showPostContentNetwork:1,
      createdDateSort: true,
      dataSetType: 'deliverables',
      reloadCounter: 0,
      GSCreatedDatePopover: false,

      customCreatedDateRanges: {
        Yesterday: [
          this.$moment().subtract(1, "days").toDate(),
          this.$moment().subtract(1, "days").toDate(),
        ],
        "Last week": [
          this.$moment().subtract(7, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        "Last two week": [
          this.$moment().subtract(14, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        Today: [this.$moment().toDate(), this.$moment().toDate()],
        "This week": [
          this.$moment().startOf("week").toDate(),
          this.$moment().endOf("week").toDate(),
        ],
      },
      customCompletedDateRanges: {
        Yesterday: [
          this.$moment().subtract(1, "days").toDate(),
          this.$moment().subtract(1, "days").toDate(),
        ],
        "Last week": [
          this.$moment().subtract(7, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        "Last two week": [
          this.$moment().subtract(14, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        Today: [this.$moment().toDate(), this.$moment().toDate()],
        "This week": [
          this.$moment().startOf("week").toDate(),
          this.$moment().endOf("week").toDate(),
        ],
      },
      customPublishDateRanges: {
        Yesterday: [
          this.$moment().subtract(1, "days").toDate(),
          this.$moment().subtract(1, "days").toDate(),
        ],
        "Last week": [
          this.$moment().subtract(7, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        "Last two week": [
          this.$moment().subtract(14, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        Today: [this.$moment().toDate(), this.$moment().toDate()],
        "This week": [
          this.$moment().startOf("week").toDate(),
          this.$moment().endOf("week").toDate(),
        ],
      },
      searchQuery: "",
      isContactsLoading: false,
      isTagsLoading: false,
      isProjectPlansLoading: false,
      isSocialSeriesLoading: false,
      isSocialCampaignsLoading: false,
      isDepartmentsLoading: false,
      contacts: [],
      tags: [],
      parentDeliverables:[],
      socialSeriesPlural: [], // Does this look wrong? Yes but how else do I differentiate plural and singular like tags/tag socialCampaigns/socialCampaign? Well if you don't like it than change it idc.
      socialCampaigns: [],
      departments: [],
      showUserSelect: false,
      expandAll: !this.isMobile(),
      selectedCoordinators: [],
      selectedSocialNetworks: [],
      selectedTags: [],
      selectedParentDeliverables:[],
      selectedDepartments: [],
      selectedSocialCampaigns: [],
      selectedSocialSeries: [],
      selectedHasPostDate: {
        id: null,
        name: "All"
      },
      hasPostDateFilterOptions: [
        {
          id: null,
          name: "All"
        },
        {
          id: '0',
          name: "No Post Date"
        },
        {
          id: '1',
          name: "Has Post Date"
        },
      ],
      planFilterQuery: {
        sort: "",
        multiSort: ["title:asc"],
        query: "",
        hasPostDate: null,
        groupSeriesPosts:true,
        filterByDate: false,
        filterByTaskDate: false,
        listByPublishDate: false,
        listByDate: true,
        listByDateField: "title",
        listByDateRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        dateRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        taskDateRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        dateCreatedRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        dateCompletedRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        datePublishRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        listDatePublishRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        status: [],
        outlet: [],
        deliverableType: [],
        publishStatus: [],
        socialNetwork: [],
        tag: [],
        socialSeries: [],
        socialCampaign: [],
        department: [],
        coordinator: [],
        project: [],
        parentDeliverableId: 0,
        filterParentDeliverable: [],
        noDepartment: "not_accepted",
        noOutlet: "not_accepted",
        weekFilterOptions: {
          overdue: false,
          today: false,
          thisWeek: false,
          nextWeek: false,
          upcoming: false,
          noDeadline: false,
        }
      },
    };
  },
  components: {
    VueFilePond,
  	Logo,
    vueStarRate,
    HeaderNotification,
    LoggedInUser,
    FeedbackBtn,
    FeedbackModal,
    ViewTitleModal,
  },
  computed: {
    ...mapGetters([
      "userAbilities",
    ]),
    ...mapState({
      state(state) {
        return state[this.namespace]
      },

			getAvailableSocialNetworks(state, getters) {
			  return getters['getAvailableSocialNetworks']
			},


      showPostContentNetworkInListing(state, getters) {
        return getters['showPostContentNetworkInListing']
      },
      showPostContentLangInListing(state, getters) {
        return getters['showPostContentLangInListing']
      },

      getSocialNetworkClass(state, getters) {
        return getters['getSocialNetworkClass']
      },
      deliverableTypes(state, getters) {
        return getters[this.namespace + 'deliverableTypes']
      },
      deliverablePublishStatus(state, getters) {
        return getters[this.namespace + 'deliverablePublishStatus']
      },
      allCustomFields(state, getters) {
        return getters[this.namespace + 'allCustomFields']
      },
      allUsers(state, getters) {
        return getters['allUsers']
      },
      allActiveUsers(state, getters) {
        return getters[this.namespace + 'allActiveUsers']
      },
      allDepartments(state, getters) {
        return getters[this.namespace + 'allDepartments']
      },
      allActiveDepartments(state, getters) {
        return getters[this.namespace + 'allActiveDepartments']
      },
      allContacts(state, getters) {
        return getters[this.namespace + 'allContacts']
      },
      allActiveContacts(state, getters) {
        return getters[this.namespace + 'allActiveContacts']
      },
      allTags(state, getters) {
        return getters[this.namespace + 'allTags']
      },
      allSocialSeries(state, getters) {
        return getters[this.namespace + 'allSocialSeries']
      },
      allSocialCampaigns(state, getters) {
        return getters[this.namespace + 'allSocialCampaigns']
      },
      socialMediaFilter(state, getters) {
        return getters[this.namespace + 'socialMediaFilter']
      },
      socialMediaCalendarFilter(state, getters) {
        return getters[this.namespace + 'socialMediaCalendarFilter']
      },
      myWeekDeliverableFilter(state, getters) {
        return getters[this.namespace + 'myWeekDeliverableFilter']
      },
      mediaCallFilter(state, getters) {
        return getters[this.namespace + 'mediaCallFilter']
      },
      globalSearchFilter(state, getters) {
        return getters[this.namespace + 'globalSearchFilter']
      },
      currentPage(state, getters) {
        return getters[this.namespace + 'currentPage']
      },
      initialContacts(state, getters) {
        return getters[this.namespace + 'initialContacts']
      },
      initialTags(state, getters) {
        return getters[this.namespace + 'initialTags']
      },
      initialDepartments(state, getters) {
        return getters[this.namespace + 'initialDepartments']
      },
      GSRecentSearch(state, getters) {
        return getters[this.namespace + 'GSRecentSearch']
      },
      userViews(state, getters) {
        return getters[this.namespace + 'userViews']
      },
      allProjects(state, getters) {
        return getters[this.namespace + 'allProjects']
      },
      systemSettings(state, getters) {
        return getters['systemSettings']
      },
      socialGroupBy(state, getters) {
        return getters[this.namespace + 'socialGroupBy']
      },
      getSystemSetting(state, getters) {
        return getters[this.namespace + 'getSystemSetting']
      },
    }),
    filterBoxBtnRef() {
      return `filterBoxBtn-${this.tabTitle}`;
    },
    popoverTarget() {
      return `sm-plan-popover-button-event-${this.tabTitle}`;
    },
    querySearchPlaceHolder() {
      if (this.$router.currentRoute.name == 'globalSearch') {
        return 'Global search...'
      } else {
        return 'Search...'
      }
    },




    statuses() {
      let statusField = _.find(this.allCustomFields, { field_key: "project_status" });
      if (typeof statusField != "undefined") {
        let valueSet = [],
          data = JSON.parse(statusField.value_set);
        Object.keys(data).forEach(function (item) {
          valueSet.push(data[item]);
        });
        return valueSet;
      }
    },
    publishStatuses() {
      if (this.systemSettings) {
        if (this.systemSettings.publish_statuses) {
          return this.systemSettings.publish_statuses;
        }
      }
      return [];
    },
    checkPermissions() {
      switch (this.GSDataType) {
        case "tags":
          return (
            this.userAbilities.createTag || this.userAbilities.editMediaCall
          );
        case "contacts":
          return (
            this.userAbilities.createContact || this.userAbilities.editMediaCall
          );
        case "coordinators":
          return this.userAbilities.createUser;
        case "departments":
          return (
            this.userAbilities.createDepartment ||
            this.userAbilities.editMediaCall
          );
      }
    },
    tabType() {
      return typeof this.GSDataType != "undefined" ? this.GSDataType : "";
    },

    getHeaderClasses() {
      let c = "col-sm-12 col-md-12 col-12 left-side";

      if (this.showLogo) {
        c = "col-sm-5 col-md-8 col-8 left-side";
      }
      return c;

    },

    showPlanProjectAll() {
    		// Not using this feature for now.
    		return false;


    		if (this.$router.currentRoute.name != "socialMedia") {
    			return true;
    		}
    		return false;
    },
  },

  mounted() {

    // Changed this because create deliverable is a split button so we need an inital type
    this.initDeliverableTypes()
    // hiding the header logo when scrolling in mobile
    if (this.isMobile() && this.$store.getters.isLoggedIn) {

      $('html').removeClass('is__safari');
      var prevScrollpos = window.pageYOffset;
      window.onscroll = function () {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos) {
          document.getElementById("header__controls").style.top = "0";
        } else {
          document.getElementById("header__controls").style.top = "-60px";
        }
        prevScrollpos = currentScrollPos;
      }
    }

    this.$root.$on('bv::popover::show', this.onBvPopoverShow);

    this.$root.$on('bv::popover::hide', this.onBvPopoverHide);
    this.$root.$on(this.namespace + 'setSaveView', this.onSetSaveView);
    this.$root.$on(this.namespace + 'resetFilter', this.onResetFilter);
    this.$root.$on(this.namespace + 'socialMediaFilterQueryUpdate', this.onSocialMediaFilterQueryUpdate);

    // Used for when the calendar set the view for publish status
    this.$root.$on(this.namespace + 'calendarSetView', this.onCalendarViewChange);

    this.onWhoSearch("");
    this.onTagSearch("");
    this.onDepartmentSearch("");

    this.planFilterQuery = this.socialMediaFilter;
    
    if (this.planFilterQuery.query) {
      this.searchQuery = this.planFilterQuery.query;
    }

  	// always default to All for organic social media
  	if (this.namespace == "relatedDeliverables/") {
	  	this.planFilterQuery.listByDateRange = {
	  	  startDate: null,
	  	  endDate: null,
	  	};
	  }


    // always default to plan.
  	this.showLimitedTo = "plan";
    this.planFilterQuery["limitDeliverablesTo"] = "plan";


    if (typeof this.planFilterQuery.filterParentDeliverable == "undefined") {
    	this.planFilterQuery.filterParentDeliverable = [];
    } 

    if (this.planFilterQuery.sortByDateField == "created_at") {
      this.createdDateSort = true;
    } else {
      this.createdDateSort = false;
    }


    if (!this.planFilterQuery.filterByDateCreated) {
      this.planFilterQuery.dateCreatedRange = {
        startDate: new Date(),
        endDate: new Date(),
      };
    }

    if (!this.planFilterQuery.filterByPublishDate) {
      this.planFilterQuery.datePublishRange = {
        startDate: new Date(),
        endDate: new Date(),
      };
    }

    if (!Array.isArray(this.planFilterQuery.multiSort) || !this.planFilterQuery.multiSort.length) {
      this.planFilterQuery.multiSort = ['title:asc'];
    }
    this.initMultiselectFromStoreFilter();
    this.setupRefresh();
    this.applyFilter();
  },
  destroyed() {
    this.$root.$off('bv::popover::show', this.onBvPopoverShow);
    this.$root.$off('bv::popover::hide', this.onBvPopoverHide);
    this.$root.$off(this.namespace + 'setSaveView', this.onSetSaveView);
    this.$root.$off(this.namespace + 'resetFilter', this.onResetFilter);
    this.$root.$off(this.namespace + 'socialMediaFilterQueryUpdate', this.onSocialMediaFilterQueryUpdate);
    this.$root.$off(this.namespace + 'calendarSetView', this.onCalendarViewChange);
  },


  methods: {
    ...mapActions({
      getDeliverableTypes(dispatch, payload) {
        return dispatch(this.namespace + 'getDeliverableTypes', payload)
      },
      getCalendarData(dispatch, payload) {
        return dispatch(this.namespace + 'getCalendarData', payload)
      },
      fetchAllProjects(dispatch, payload) {
        return dispatch(this.namespace + 'fetchAllProjects', payload)
      },
      fetchSocialSeries(dispatch, payload) {
        return dispatch(this.namespace + 'fetchSocialSeries', payload)
      },
      fetchSocialCampaigns(dispatch, payload) {
        return dispatch(this.namespace + 'fetchSocialCampaigns', payload)
      },
      startDownloadDeliverableExcel(dispatch, payload) {
        return dispatch(this.namespace + 'startDownloadDeliverableExcel', payload)
      },
    }),
    ...mapMutations({
      setDataLoading(commit, payload) {
        return commit(this.namespace + 'setDataLoading', payload)
      },
      setSocialGroupBy(commit, payload) {
        return commit(this.namespace + 'setSocialGroupBy', payload)
      },
    }),

     apiUrl() {
        return process.env.MIX_API_BASE_URL;
      },
    getImportStatusClass(status) {
    	let css = "imported-status ";
    	return css + "imported-status-"+status.slug;
  	},

  	showEditDeliverableModal(d) {
  		let openId = d.id;
  		if (d.social_series) {
  			if (d.social_series.master_deliverable_id != d.id) {
  				openId = d.social_series.master_deliverable_id;
  			}
  		}

  		this.$emit("showEditDeliverableModal", openId, 0);
  	},


      // Resource upload file
    handleFilePondInit() {
    	console.log(this.apiUrl());

    	var theUrl = this.apiUrl() + "importSocialMedia";

      this.$refs.importPond._pond.setOptions({
        server: {
						headers: {
							Authorization: "Bearer " + this.$store.getters.authToken
						},
						process: {
							method: 'POST',
							url: theUrl,
							withCredentials: true,
              ondata: this.handleFilePondSubmit,
              onload: this.handleFilePondSuccess,
              onerror:this.handleFilePondError,
          },
        }
      });
    },
    handleFilePondSubmit(data) {
    	this.isProcessingImport = true;
    	this.isLoadingImport = true;
    	this.loadedImportResults = false;
    	this.importedResults = {
    		imported:[],
    		errors:[]
    	};

      return data;
    },


    handleFilePondSuccess(response, file) {
    	this.importedResults = JSON.parse(response);
    	for (var x = 0; x < 10; x++) {
    		for (var y = 0; y < this.importedResults.length; y++) {
    			this.importedResults.imported.push(this.importedResults.imported[$y]);
    		}
    		if (this.importedResults.imported.length > 20) {
    			break;
    		}
    	}
    	this.isLoadingImport = false;
    	this.loadedImportResults = true;
    	this.isProcessingImport = false;
    	this.applyFilterAndFirstPage();
    	if (file) {
	    	this.$nextTick(() => {
	    	    this.$refs.importPond.removeFile(file.id);
	    	});
	    }

    },

        handleFilePondError(response, file) {
        	this.isLoadingImport = false;
        	this.loadedImportResults = true;
        	this.isProcessingImport = false;
        	// if (file) {
    	    // 	this.$nextTick(() => {
    	    // 	    this.$refs.importPond.removeFile(file.id);
    	    // 	});
    	    // }
        },

    isFilterActive() {
      if (router.currentRoute.name == "myWeek") {
        return (
          this.planFilterQuery.noDepartment == 'accepted'
          || this.planFilterQuery.filterNoDueDate
          || this.planFilterQuery.query
          || this.planFilterQuery.status.length
          || this.planFilterQuery.publishStatus.length
          || this.planFilterQuery.filterByDateCreated
          || this.planFilterQuery.filterByDateCompleted
          || this.planFilterQuery.filterByPublishDate
          || this.planFilterQuery.coordinator.length
          || this.planFilterQuery.tag.length
          || this.planFilterQuery.socialSeries.length
          || this.planFilterQuery.socialCampaign.length
          || this.planFilterQuery.department.length
          || this.planFilterQuery.filterParentDeliverable.length
          || this.planFilterQuery.sort
          || this.planFilterQuery.project.length
          || this.planFilterQuery.weekFilterOptions.overdue
          || this.planFilterQuery.weekFilterOptions.today
          || this.planFilterQuery.weekFilterOptions.thisWeek
          || this.planFilterQuery.weekFilterOptions.nextWeek
          || this.planFilterQuery.weekFilterOptions.upcoming
          || this.planFilterQuery.weekFilterOptions.noDeadline
          || this.planFilterQuery.hasPostDate
        )
      } else {
        return (
          this.planFilterQuery.noDepartment == 'accepted'
          || this.planFilterQuery.filterNoDueDate
          || this.planFilterQuery.query
          || this.planFilterQuery.status.length
          || this.planFilterQuery.publishStatus.length
          || this.planFilterQuery.filterByDateCreated
          || this.planFilterQuery.filterByDateCompleted
          || this.planFilterQuery.filterByPublishDate
          || this.planFilterQuery.coordinator.length
          || this.planFilterQuery.filterParentDeliverable.length
          || this.planFilterQuery.tag.length
          || this.planFilterQuery.socialSeries.length
          || this.planFilterQuery.socialCampaign.length
          || this.planFilterQuery.department.length
          || this.planFilterQuery.sort
          || this.planFilterQuery.socialNetwork.length
          || this.planFilterQuery.project.length
          || this.planFilterQuery.hasPostDate
        )
      }

    },
    exportSocialMediaExcel() {
     	let that = this;
     		if (this.planFilterQuery) {
     			this.showSocialMediaExportModal = true;
     			this.isLoadingExport = true;
     			this.downloadError = "";

     			// don't group master series posts. show all of them.
					var customFilter = _.cloneDeep(this.planFilterQuery);
					customFilter.groupSeriesPosts = false;
					customFilter.includeMasterPosts = true;
					customFilter.listByDate = true;
					customFilter.listByDateField = "title";


     			this.startDownloadDeliverableExcel(customFilter).then(function(response) {
     				if (response.data.token != "") {
     						that.downloadLink = process.env.MIX_API_BASE_URL + "downloadFile/" + response.data.token;
     				} else {
     						that.downloadLink = "";
     						that.downloadError = "Invalid download token returned from server.";
     				}
     				that.isLoadingExport = false;
            }).catch(function (error) {
              that.downloadLink = "";
              that.isLoadingExport = false;
              that.showSocialMediaExportModal = false;
            });
     		}
    },

    importSocialMediaExcel() {
				let that = this;
				if (this.planFilterQuery) {
					this.showSocialMediaImportModal = true;
					this.isLoadingImport = true;
					this.uploadError = "";
					this.importFilterQuery = this.planFilterQuery;
				}
		},




    createDeliverableType(deliverableType) {
      this.$store.dispatch(this.namespace + "createDeliverableType", { deliverableType });
    },
    toggleStatusView() {
      if (this.isMobile()) {
        if (this.expandAll) {
          $('.deliverable-status-overview').hide();
          $('.deliverable-dates').css('padding-top', 0);
        } else {
          $('.deliverable-status-overview').show();
          $('.deliverable-dates').css('padding-top', '15px');
        }
      }
    },

    removeView(viewId) {
      this.$store.dispatch('removeView', viewId);
    },
    loadView() {
      this.planFilterQuery = this.socialMediaFilter;
      if (typeof this.planFilterQuery.filterParentDeliverable == "undefined") {
      	this.planFilterQuery.filterParentDeliverable = [];
      }

    },
    saveView() {
      this.$bvModal.show("viewTitleModal");
    },
    setLimit(limit) {
    	this.showLimitedTo = limit;
      this.planFilterQuery["limitDeliverablesTo"] = limit;
      this.applyFilterAndFirstPage();

    },
    setSort(sortType) {
      this.planFilterQuery["sort"] = sortType;
    },
    setQuery() {
      this.planFilterQuery.query = this.searchQuery;
      if (this.$router.currentRoute.name == 'globalSearch') {
        let searchQuery = this.searchQuery;
        let activeTab = this.GSDataType;
        this.$store.commit(this.namespace + "setRecentSearch", { searchQuery, activeTab });
      }
      this.applyFilterAndFirstPage();
    },

    onUpdateDateCreated() {
      this.planFilterQuery.filterByDateCreated = true;
      this.focusFilterBtn();
      this.applyFilterAndFirstPage();
    },

    onUpdatePublishDate() {
      this.planFilterQuery.filterByPublishDate = true;
      this.focusFilterBtn();
      this.applyFilterAndFirstPage();
    },

    initMultiselectFromStoreFilter() {
      // If item doesn't exist, insert it into v-model
      // when moving between components, selected tags will show in multiselect
      if (this.planFilterQuery.coordinator.length > 0) {
        this.planFilterQuery.coordinator.map(item => {
          if (!this.selectedCoordinators.some(tag => tag.id === item.id)) {
            this.selectedCoordinators.push(item);
          }
        });
      }
      if (this.planFilterQuery.socialNetwork.length > 0) {
        this.planFilterQuery.socialNetwork.map(item => {
          if (!this.selectedSocialNetworks.some(tag => tag.id === item.id)) {
            this.selectedSocialNetworks.push(item);
          }
        });
      }
      if (this.planFilterQuery.filterParentDeliverable.length > 0) {
        this.planFilterQuery.filterParentDeliverable.map(item => {
          if (!this.selectedParentDeliverables.some(tag => tag.id === item.id)) {
            this.selectedParentDeliverables.push(item);
          }
        });
      }
      if (this.planFilterQuery.tag.length > 0) {
        this.planFilterQuery.tag.map(item => {
          if (!this.selectedTags.some(tag => tag.id === item.id)) {
            this.selectedTags.push(item);
          }
        });
      }
      if (this.planFilterQuery.department.length > 0) {
        this.planFilterQuery.department.map(item => {
          if (!this.selectedDepartments.some(tag => tag.id === item.id)) {
            this.selectedDepartments.push(item);
          }
        });
      }
    },

    onUpdateMultiselect(selectedOption, id) {
      switch (id) {
        case "coordinator":
          if (!this.planFilterQuery.coordinator.some(coordinator => coordinator.id === selectedOption.id)) {
            this.planFilterQuery.coordinator.push(selectedOption);
          }
          break;
        case "projectPlan":
          if (!this.planFilterQuery.filterParentDeliverable.some(filterParentDeliverable => filterParentDeliverable.id === selectedOption.id)) {
            this.planFilterQuery.filterParentDeliverable.push(selectedOption);
          }
          break;
        case "socialNetwork":
          if (!this.planFilterQuery.socialNetwork.some(socialNetwork => socialNetwork.id === selectedOption.id)) {
            this.planFilterQuery.socialNetwork.push(selectedOption);
          }
          break;
        case "socialCampaign":
          this.planFilterQuery.socialCampaign.push(selectedOption);
          break;
        case "socialSeries":
          this.planFilterQuery.socialSeries.push(selectedOption);
          break;
        case "tag":
          if (!this.planFilterQuery.tag.some(tag => tag.id === selectedOption.id)) {
            this.planFilterQuery.tag.push(selectedOption);
          }
          break;
        case "department":
          if (!this.planFilterQuery.department.some(department => department.id === selectedOption.id)) {
            this.planFilterQuery.department.push(selectedOption);
          }
          this.planFilterQuery.noDepartment = 'not_accepted';
          break;
        case "hasPostDate":
          this.planFilterQuery.hasPostDate = selectedOption.id;
          break;
        default:
          break;
      }
      this.focusFilterBtn();
      this.applyFilterAndFirstPage();
    },

    onRemoveMultiselect(removedOption, id) {
      switch (id) {
        case "coordinator":
          this.planFilterQuery.coordinator = this.planFilterQuery.coordinator.filter(obj => obj.id !== removedOption.id);
          break;
        case "projectPlan":
          this.planFilterQuery.filterParentDeliverable = this.planFilterQuery.filterParentDeliverable.filter(obj => obj.id !== removedOption.id);
          break;
        case "socialNetwork":
          this.planFilterQuery.socialNetwork = this.planFilterQuery.socialNetwork.filter(obj => obj.id !== removedOption.id);
          break;
        case "socialCampaign":
          this.planFilterQuery.socialCampaign = this.planFilterQuery.socialCampaign.filter(obj => obj.id !== removedOption.id);
          break;
        case "socialSeries":
          this.planFilterQuery.socialSeries = this.planFilterQuery.socialSeries.filter(obj => obj.id !== removedOption.id);
          break;
        case "tag":
          this.planFilterQuery.tag = this.planFilterQuery.tag.filter(obj => obj.id !== removedOption.id);
          break;
        case "department":
          this.planFilterQuery.department = this.planFilterQuery.department.filter(obj => obj.id !== removedOption.id);
          if (this.planFilterQuery.department.length == 0) {
            this.planFilterQuery.noDepartment = 'accepted';
          }
          break;
        case "hasPostDate":
          this.planFilterQuery.hasPostDate = removedOption.id;
          break;
        default:
          break;
      }
      this.focusFilterBtn();
      this.applyFilterAndFirstPage();
    },

    onWhoSearch(input) {
      if (input != "" || this.initialContacts.length == 0) {
        this.isContactsLoading = true;
        if (typeof window.LIT !== "undefined") {
          clearTimeout(window.LIT);
        }
        window.LIT = setTimeout(() => {
          input = input == false ? "" : input;
          new Promise((resolve, reject) => {
            axios
              .get(
                process.env.MIX_API_BASE_URL + "activeContacts?q=" + encodeURI(input)
              )
              .then((resp) => {
                this.isContactsLoading = false;
                this.contacts = [];
                let x = 0;
                for (x = 0; x < resp.data.length; x++) {
                  resp.data[x]["name"] =
                    resp.data[x]["first_name"] +
                    " " +
                    resp.data[x]["last_name"];
                  this.contacts.push(resp.data[x]);
                }
                this.$store.commit(this.namespace + "setInitialData", {
                  contacts: this.contacts,
                });
                resolve(this.contacts);
              })
              .catch((error) => {
                reject(error);
              });
          });
        }, 500);
      } else {
        this.contacts = this.initialContacts;
      }
    },





    onProjectPlanSearch(input) {
      this.isProjectPlansLoading = true;
      if (typeof window.LIT1 !== "undefined") {
        clearTimeout(window.LIT1);
      }
      window.LIT1 = setTimeout(() => {
        if (input != "" || this.initialTags.length == 0) {
          input = input == false ? "" : input;
          new Promise((resolve, reject) => {
            axios
              .get(process.env.MIX_API_BASE_URL + "searchProjectParentDeliverables?deliverable_template_slug=organic-social-media-plan&q=" + encodeURI(input))
              .then((resp) => {
                this.isProjectPlansLoading = false;
                this.parentDeliverables = [];
                let x = 0;
                for (x = 0; x < resp.data.length; x++) {
                  this.parentDeliverables.push(resp.data[x]);
                }
                // this.$store.commit(this.namespace + "setInitialData", { parentDeliverables: this.parentDeliverables });
                resolve(this.parentDeliverables);
              })
              .catch((error) => {
                reject(error);
              });
          });
        } else {
          this.isProjectPlansLoading = false;
          this.parentDeliverables = [];
        }
      }, 1000);
    },

    onTagSearch(input) {
      this.isTagsLoading = true;
      if (typeof window.LIT1 !== "undefined") {
        clearTimeout(window.LIT1);
      }
      window.LIT1 = setTimeout(() => {
        if (input != "" || this.initialTags.length == 0) {
          input = input == false ? "" : input;
          new Promise((resolve, reject) => {
            axios
              .get(process.env.MIX_API_BASE_URL + "tags?q=" + encodeURI(input))
              .then((resp) => {
                this.isTagsLoading = false;
                this.tags = [];
                let x = 0;
                for (x = 0; x < resp.data.length; x++) {
                  this.tags.push(resp.data[x]);
                }
                this.$store.commit(this.namespace + "setInitialData", { tags: this.tags });
                resolve(this.tags);
              })
              .catch((error) => {
                reject(error);
              });
          });
        } else {
          this.isTagsLoading = false;
          this.tags = this.initialTags;
        }
      }, 500);
    },
    onSocialSeriesSearch(input) {
      this.isSocialSeriesLoading = true;
      if (typeof window.socialSeriesSearchDebounce !== "undefined") {
        clearTimeout(window.socialSeriesSearchDebounce);
      }
      window.socialSeriesSearchDebounce = setTimeout(() => {
        if (input != "" || this.allSocialSeries.length == 0) {
          input = input == false ? "" : input;
          new Promise((resolve, reject) => {
            axios
              .get(process.env.MIX_API_BASE_URL + "socialSeries?q=" + encodeURI(input))
              .then((resp) => {
                this.isSocialSeriesLoading = false;
                this.socialSeriesPlural = [];
                let x = 0;
                for (x = 0; x < resp.data.length; x++) {
                  this.socialSeriesPlural.push(resp.data[x]);
                }
                this.$store.commit(this.namespace + "setInitialData", { socialSeriesPlural: this.socialSeriesPlural });
                resolve(this.socialSeriesPlural);
              })
              .catch((error) => {
                reject(error);
              });
          });
        } else {
          this.isSocialSeriesLoading = false;
          this.socialSeriesPlural = this.allSocialSeries;
        }
      }, 500);
    },
    onSocialCampaignSearch(input) {
      this.isSocialCampaignsLoading = true;
      if (typeof window.socialCampaignSearchDebounce !== "undefined") {
        clearTimeout(window.socialCampaignSearchDebounce);
      }
      window.socialCampaignSearchDebounce = setTimeout(() => {
        if (input != "" || this.allSocialCampaigns.length == 0) {
          input = input == false ? "" : input;
          new Promise((resolve, reject) => {
            axios
              .get(process.env.MIX_API_BASE_URL + "socialCampaigns?q=" + encodeURI(input))
              .then((resp) => {
                this.isSocialCampaignsLoading = false;
                this.socialCampaigns = [];
                let x = 0;
                for (x = 0; x < resp.data.length; x++) {
                  this.socialCampaigns.push(resp.data[x]);
                }
                this.$store.commit(this.namespace + "setInitialData", { socialCampaigns: this.socialCampaigns });
                resolve(this.socialCampaigns);
              })
              .catch((error) => {
                reject(error);
              });
          });
        } else {
          this.isSocialCampaignsLoading = false;
          this.socialCampaigns = this.allSocialCampaigns;
        }
      }, 500);
    },
    onDepartmentSearchClose(input) {

    },
    onDepartmentSearch(input) {
      if (input != "" || this.initialDepartments.length == 0) {
        this.isDepartmentsLoading = true;
        if (typeof window.LIT2 !== "undefined") {
          clearTimeout(window.LIT2);
        }
        window.LIT2 = setTimeout(() => {
          input = input == false ? "" : input;
          new Promise((resolve, reject) => {
            axios
              .get(
                process.env.MIX_API_BASE_URL +
                "departments?q=" +
                encodeURI(input)
              )
              .then((resp) => {
                this.isDepartmentsLoading = false;
                this.departments = [];
                let x = 0;
                for (x = 0; x < resp.data.length; x++) {
                  this.departments.push(resp.data[x]);
                }
                this.$store.commit(this.namespace + "setInitialData", {
                  departments: this.departments,
                });
                resolve(this.departments);
              })
              .catch((error) => {
                this.isTagsLoading = false;
                reject(error);
              });
          });
        }, 500);
      } else {
        this.departments = this.initialDepartments;
      }
    },
    resetFilter() {
      this.$root.$emit(this.namespace + 'resetView');
      this.planFilterQuery.filterNoDueDate = false;
      this.planFilterQuery.filterNoTaskDueDate = false;
      this.planFilterQuery.noDepartment = "not_accepted";
      this.planFilterQuery.query = null;
      this.planFilterQuery.hasPostDate = null;
      this.planFilterQuery.parentDeliverableId = this.parentDeliverableId;
      this.searchQuery = "";
      $('.filter-rating .vue-star-rate ul li').each(function () {
        $(this).removeClass('active');
      })

      this.planFilterQuery.filterByDateCreated = false;
      this.planFilterQuery.dateCreatedRange = {
        startDate: new Date(),
        endDate: new Date(),
      };

      this.planFilterQuery.filterByPublishDate = false;
      this.planFilterQuery.datePublishRange = {
        startDate: new Date(),
        endDate: new Date(),
      };

      this.planFilterQuery.listByPublishDate = false;
      this.planFilterQuery.listDatePublishRange = {
        startDate: new Date(),
        endDate: new Date(),
      };

      this.planFilterQuery.status = [];
      this.planFilterQuery.publishStatus = [];
      this.planFilterQuery.socialNetwork = [];
      this.planFilterQuery.tag = [];
      this.planFilterQuery.socialSeries = [];
      this.planFilterQuery.socialCampaign = [];
      this.planFilterQuery.filterParentDeliverable = [];
      this.planFilterQuery.sort = '';
      this.planFilterQuery.coordinator = [];
      this.planFilterQuery.department = [];
      this.planFilterQuery.project = [];

      this.selectedCoordinators = [];
      this.selectedSocialNetworks = [];
      this.selectedTags = [];
      this.selectedDepartments = [];
      this.selectedSocialCampaigns = [];
      this.selectedSocialSeries = [];
      this.selectedHasPostDate = {
        id: null,
        name: "All"
      };

      this.applyFilterAndFirstPage();
    },
    clearSearchFilter() {
      this.planFilterQuery.query = null;
      this.searchQuery = '';
      this.applyFilterAndFirstPage();
    },
    outside() {
      this.showUserSelect = false;
    },
    createDeliverableDropdownClick(type) {
      this.deliverableType = type;
      this.createNewDeliverable();
    },
    createNewDeliverable() {

      let type = this.deliverableType.id;

      if (this.deliverableType.slug) {
      	type =  this.deliverableType.slug;
      }

      let that = this;
      this.$store.dispatch(this.namespace + "createNewDeliverable", { type, parent_deliverable_id: this.parentDeliverableId }).then(() => {
        // Accomodate the create deliverable change
        if (type == 'social_media') {
          if (that.namespace == "relatedDeliverables/" || that.namespace == "relatedDeliverablesCalendar/") {
            that.$bvModal.show('editRelatedSocialModal');
          } else {
            that.$bvModal.show('editSocialModal');
          }
        } else {
          that.$bvModal.show("editDeliverableModal");
          that.$nextTick(() => {
            $(".edit-deliverable-modal .deliverable-title").trigger("click");
          });
        }

        // if (type == "social_media") {
        // 	let filterObj = {};
        // 	if (typeof this.pageCount != "undefined") {
        // 		filterObj = { pageCount: this.pageCount };
        // 	}
        // 	filterObj.page = 1;
        //   that.$store.dispatch(that.namespace + "fetchSocialMediaDeliverablesGrouped", filterObj);
        // } else {
        //   that.$store.dispatch(that.namespace + "fetchDeliverables", this.currentPage);
        //   that.$store.dispatch(that.namespace + "fetchDeliverableCount");
        // }
        this.applyFilterAndFirstPage();
      });
    },
    setStatusFilter(status) {
      if (this.planFilterQuery.status.indexOf(status) != -1) {
        this.removeFilter(status);
      } else {
        this.planFilterQuery.status.push(status);
      }
      this.applyFilterAndFirstPage();
    },
    setPublishStatusFilter(publishStatus) {
      if (this.planFilterQuery.publishStatus.indexOf(publishStatus) != -1) {
        this.removeFilter(publishStatus);
      } else {
        this.planFilterQuery.publishStatus.push(publishStatus);
      }
      this.applyFilterAndFirstPage();
    },
    removeFilter(data) {
      if (typeof data != "undefined") {
        if (typeof data == "string") {
          if (
            this.$router.currentRoute.name == "globalSearch" &&
            data == "resetDepartStatus"
          ) {
            this.planFilterQuery.status = [];
          }
          if (
            this.$router.currentRoute.name == "globalSearch" &&
            data == "resetDepartTagSort"
          ) {
            this.planFilterQuery.sort = "";
          }
          if (
            this.$router.currentRoute.name != "globalSearch" &&
            data == "resetDeliverableSort"
          ) {
            this.planFilterQuery.sort = "";
          }
          if (data == "filterByDateCreated") {
            this.planFilterQuery.filterByDateCreated = false;
            this.planFilterQuery.dateCreatedRange.startDate = new Date();
            this.planFilterQuery.dateCreatedRange.endDate = new Date();
          }
          if (data == "filterByPublishDate") {
            this.planFilterQuery.filterByPublishDate = false;
            this.planFilterQuery.datePublishRange.startDate = new Date();
            this.planFilterQuery.datePublishRange.endDate = new Date();
          }

          if (data == "overdue") {
            this.planFilterQuery.weekFilterOptions.overdue = false;
          }
          if (data == "today") {
            this.planFilterQuery.weekFilterOptions.today = false;
          }
          if (data == "thisWeek") {
            this.planFilterQuery.weekFilterOptions.thisWeek = false;
          }
          if (data == "nextWeek") {
            this.planFilterQuery.weekFilterOptions.nextWeek = false;
          }
          if (data == "upcoming") {
            this.planFilterQuery.weekFilterOptions.upcoming = false;
          }
          if (data == "noDeadline") {
            this.planFilterQuery.weekFilterOptions.noDeadline = false;
          }
          if (data == "hasPostDate") {
            this.planFilterQuery.hasPostDate = null;
            this.selectedHasPostDate = {
              id: null,
              name: "All"
            };
          }

        } else {

          if (typeof this.planFilterQuery.status != "undefined") {
            this.planFilterQuery.status = this.planFilterQuery.status.filter((s) => {
              return s.name != data.name;
            });
          }

          if (typeof this.planFilterQuery.publishStatus != "undefined") {
            this.planFilterQuery.publishStatus = this.planFilterQuery.publishStatus.filter((s) => {
              return s.name != data.name;
            });
          }

          if (typeof this.planFilterQuery.socialNetwork != "undefined") {
            this.planFilterQuery.socialNetwork = this.planFilterQuery.socialNetwork.filter((s) => {
              return s.id != data.id;
            });
            this.selectedSocialNetworks = this.selectedSocialNetworks.filter(
              (s) => {
                return s.name != data.name;
              }
            );
          }

          if (typeof this.planFilterQuery.coordinator != "undefined") {
            this.planFilterQuery.coordinator = this.planFilterQuery.coordinator.filter(
              (s) => {
                return s.name != data.name;
              }
            );
            this.selectedCoordinators = this.selectedCoordinators.filter(
              (s) => {
                return s.name != data.name;
              }
            );
          }

          if (typeof this.planFilterQuery.tag != "undefined") {
            this.planFilterQuery.tag = this.planFilterQuery.tag.filter((s) => {
              return s.name != data.name;
            });
            this.selectedTags = this.selectedTags.filter(
              (s) => {
                return s.name != data.name;
              }
            );
          }

          if (typeof this.planFilterQuery.filterParentDeliverable != "undefined") {
            this.planFilterQuery.filterParentDeliverable = this.planFilterQuery.filterParentDeliverable.filter((s) => {
              return s.name != data.name;
            });
            this.selectedParentDeliverables = this.selectedParentDeliverables.filter(
              (s) => {
                return s.name != data.name;
              }
            );
          }



          if (typeof this.planFilterQuery.socialSeries != "undefined") {
            this.planFilterQuery.socialSeries = this.planFilterQuery.socialSeries.filter((s) => {
              return s.name != data.name;
            });
            this.selectedSocialSeries = this.selectedSocialSeries.filter(
              (s) => {
                return s.name != data.name;
              }
            );
          }

          if (typeof this.planFilterQuery.socialCampaign != "undefined") {
            this.planFilterQuery.socialCampaign = this.planFilterQuery.socialCampaign.filter((s) => {
              return s.name != data.name;
            });
            this.selectedSocialCampaigns = this.selectedSocialCampaigns.filter(
              (s) => {
                return s.name != data.name;
              }
            );
          }

          if (typeof this.planFilterQuery.department != "undefined") {
            this.planFilterQuery.department = this.planFilterQuery.department.filter(
              (s) => {
                return s.name != data.name;
              }
            );
            this.selectedDepartments = this.selectedDepartments.filter(
              (s) => {
                return s.name != data.name;
              }
            );
          }

          if (typeof this.planFilterQuery.project != "undefined") {
            this.planFilterQuery.project = this.planFilterQuery.project.filter(
              (s) => {
                return s.id != data.id;
              }
            );
          }
        }
      } else {
        // TODO:  Check if a filter can be anything other than a string or object.
      }
      this.applyFilterAndFirstPage();
    },
    triggerSearch() {
      if (this.$refs.searchQuery.value != "") {
        if (this.$router.currentRoute.name == "globalSearch") {
          this.setDataLoading(true);
          this.$store.dispatch(this.namespace + "globalSearch").then(() => {
            this.setDataLoading(false);
          });
        } else {
          this.setDataLoading(true);
          this.$store.dispatch(this.namespace + "fetchDeliverables").then(() => {
            this.setDataLoading(false);
          });
        }
      }
    },
    focusFilterBtn() {
      if (typeof this.$refs.filterBoxBtn != "undefined") {
        this.$refs.filterBoxBtn.focus();
      } else if (typeof this.$refs.GSCreatedDate != "undefined") {
        this.GSCreatedDatePopover = false;
      }
    },

    async initDeliverableTypes() {
      await this.getDeliverableTypes();
      this.deliverableType = this.deliverableTypes[0];
    },
    async initSocialSeries() {
      await this.fetchSocialSeries();
      this.socialSeriesPlural = this.allSocialSeries;
    },
    async initSocialCampaigns() {
      await this.fetchSocialCampaigns();
      this.socialCampaigns = this.allSocialCampaigns;
    },

    toggleDateSort(sortByPostingDate) {
      this.createdDateSort = sortByPostingDate;
      if (!sortByPostingDate) {
        // sorting by created date ascending
        this.planFilterQuery.listByDate = true;
        this.planFilterQuery.multiSort = ['created_at:asc'];
        this.planFilterQuery.listByDateField = "created_at";
      } else {
        // sorting by posted date ascending
        this.planFilterQuery.multiSort = [];
        this.planFilterQuery.listByDate = true;
        this.planFilterQuery.listByDateField = "publish_date";

      }
      this.applyFilterAndFirstPage();
    },
    setSortBy(field) {
    	this.sortBy = field;
    	if (field != "publish_date") {
    		// sorting by created date ascending
    		this.planFilterQuery.listByDate = true;
    		this.planFilterQuery.multiSort = [field+':asc'];
    		this.planFilterQuery.listByDateField = field;
    	} else {
    		// sorting by posted date ascending
    		this.planFilterQuery.multiSort = [];
    		this.planFilterQuery.listByDate = true;
    		this.planFilterQuery.listByDateField = "publish_date";
    	}
       this.applyFilterAndFirstPage();
    },


    setupRefresh() {
      this.planFilterQuery["myWeek"] = this.myWeek;
      this.planFilterQuery["parentDeliverableId"] = this.parentDeliverableId;
      if (typeof this.pageCount != "undefined") {
        this.planFilterQuery["pageCount"] = this.pageCount;
        this.planFilterQuery["page"] = 1;
      }
    },
    doRefresh() {

      if (router.currentRoute.name == "projectDeliverable") {
        this.$store.commit(this.namespace + "setAddProjectDeliverableFilter", JSON.stringify(this.planFilterQuery));
      }
      this.$store.commit(this.namespace + "setSocialMediaFilter", this.planFilterQuery);

      this.setDataLoading(true);
      this.$store.dispatch(this.namespace + "fetchSocialMediaDeliverablesGrouped", { filter: this.planFilterQuery, page: this.planFilterQuery.page, pageCount: this.planFilterQuery.pageCount }).then(() => {
        this.setDataLoading(false);
      });
      if (
        !this.planFilterQuery.query &&
        !this.planFilterQuery.filterByDateCreated &&
        !this.planFilterQuery.filterByPublishDate &&
        !this.planFilterQuery.status.length &&
        !this.planFilterQuery.publishStatus.length &&
        !this.planFilterQuery.socialNetwork.length &&
        !this.planFilterQuery.coordinator.length &&
        !this.planFilterQuery.tag.length &&
        !this.planFilterQuery.socialSeries.length &&
        !this.planFilterQuery.socialCampaign.length &&
        !this.planFilterQuery.department.length &&
        !this.planFilterQuery.project.length &&
        this.planFilterQuery.noDepartment != "accepted" &&
        !this.planFilterQuery.filterNoTaskDueDate &&
        !this.planFilterQuery.sort
      ) {
        $(".deliverable-listing").removeClass("hasFilter");
        $(".global-search-data-wrapper").removeClass("hasFilter");
      } else {
        $(".deliverable-listing").addClass("hasFilter");
        $(".global-search-data-wrapper").addClass("hasFilter");
      }
    },

    onBvPopoverShow(bvEventObj) {
      $('body').addClass('popover-shown');
    },

    onBvPopoverHide(bvEventObj) {
      $('body').removeClass('popover-shown');
    },


    onSetSaveView() {
      this.loadView();
    },
    onResetFilter() {
      this.resetFilter();
    },

    onSocialMediaFilterQueryUpdate(eventObj) {
      if (typeof eventObj.namespace != "undefined") {
        if (eventObj.namespace == this.namespace) {
          if (eventObj.filterParams) {

            if (eventObj.filterParams.page) {
              this.planFilterQuery.page = eventObj.filterParams.page;
            }
            if (eventObj.filterParams.pageCount) {
              this.planFilterQuery.pageCount = eventObj.filterParams.pageCount;
            }
          }
          if (eventObj.currentFilter) {
            if (this.planFilterQuery.listByDate != eventObj.currentFilter.listByDate) {
              this.planFilterQuery.listByDate = eventObj.currentFilter.listByDate;
            }
            this.planFilterQuery.listByDateField = eventObj.currentFilter.listByDateField;
            if (this.planFilterQuery.listByDateRange.endDate != eventObj.currentFilter.listByDateRange.endDate ||
              this.planFilterQuery.listByDateRange.startDate != eventObj.currentFilter.listByDateRange.startDate) {
              this.planFilterQuery.listByDateRange = eventObj.currentFilter.listByDateRange;
            }
            if (this.planFilterQuery.listByDateRange.endDate != eventObj.currentFilter.listByDateRange.endDate ||
              this.planFilterQuery.listByDateRange.startDate != eventObj.currentFilter.listByDateRange.startDate) {
              this.planFilterQuery.listByDateRange = eventObj.currentFilter.listByDateRange;
            }
          }
        }
        this.applyFilter();
      }
    },

    // Used for when the calendar set the view for publish status
    onCalendarSetView(eventObj) {
      if (eventObj.namespace) {
        if (eventObj.namespace == this.namespace) {
          this.planFilterQuery = this.socialMediaFilter;
        }
      }
      this.applyFilterAndFirstPage();
    },
    applyFilterAndFirstPage() {
      this.planFilterQuery.page = 1;
      if (this.$route.query.page != 1) {
        this.$router.push({
          name: this.$route.name,
          params: this.$route.params,
          query: { ...this.$route.query, page: 1 }
        });
      }
      this.applyFilter();
    },

    applyFilter() {
    	this.planFilterQuery.groupSeriesPosts = true;
      this.$root.$emit(this.namespace + 'showUpdateViewText', { currentFilter: this.planFilterQuery, isFilterActive: this.isFilterActive() });
      this.doRefresh();
    },


    showContentByLang(lang) {
    },
		showContentByNetwork(network) {
			// this.$store.commit(this.namespace + "setShowPostContentInListing", {lang_id:this.showPostContentLang, social_network_type_id:this.showPostContentNetwork});
		},

		 localMomentFull(value) {
		  return this.$moment.utc(value).local().format("MMM D,YYYY HH:mm a");
		},


  },
  watch: {
    allSocialCampaigns: {
      handler: async function (val, oldVal) {
        this.socialCampaigns = val;
      }
    },
    allSocialSeries: {
      handler: async function (val, oldVal) {
        this.socialSeriesPlural = val;
      }
    },
    $route(to, from) {
      if (typeof this.$route.params.socialGroupBy != 'undefined') {
        this.setSocialGroupBy(to.params.socialGroupBy);
      }
    },
    expandAll: {
      handler: function (val, oldVal) {
        this.$emit("collapseToggleUpdated", val);
      },
    },

    parentDeliverableId: {
      handler: async function (val, oldVal) {
        if (val != oldVal) {
          this.planFilterQuery["parentDeliverableId"] = val;
          this.$store.commit(this.namespace + "setSocialMediaFilter", this.planFilterQuery);
          this.$root.$emit(this.namespace + 'showUpdateViewText', { currentFilter: val, isFilterActive: 				this.isFilterActive() });
          this.setupRefresh();
          this.doRefresh();
        }
      },
      deep: true,
    },

    showPostContentLang: {
      handler: async function (val, oldVal) {
          this.$store.commit(this.namespace + "showPostContentLangInListing", this.showPostContentLang);
      }
    },
    showPostContentNetwork: {
      handler: async function (val, oldVal) {
          this.$store.commit(this.namespace + "showPostContentNetworkInListing", this.showPostContentNetwork);
      }
    },

  },
};
</script>

<style lang="scss">
.single-select {
  width: 90%;

  .multiselect__select::before {
    display: none;
  }
}

.status-processing-import-file {
  background: orange;
  color: #fff;
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 10px;
  display: flex;
}
.status-processing-import-file span  {
	padding-left:10px;
	}
.status-processing-import-file .spinner-border {
	color:#fff !important;
	margin-top:12px;

	}

</style>
